// import { request, cardRequest } from './request'
import { request } from './request'

// post请求
export function post(url, data) {
  return request({
    url,
    method: 'post',
    data,
  })
}

// get请求
export function get(url, params) {
  return request({
    url,
    method: 'get',
    params, // 请求参数拼接在url上
  })
}

// delete
export function Delete(url, data) {
  return request({
    url,
    method: 'delete',
    data, // 请求参数放在请求体
  })
}

// put
export function put(url, data) {
  return request({
    url,
    method: 'put',
    data,
  })
}


// // 电子学生证 post请求
// export function cardPost(url, data) {
//   return cardRequest({
//     url,
//     method: 'post',
//     data,
//   })
// }


// // 电子学生证 get请求
// export function cardGet(url, params) {
//   return cardRequest({
//     url,
//     method: 'get',
//     params, // 请求参数拼接在url上
//   })
// }

// // 电子学生证 delete
// export function cardDelete(url, data) {
//   return cardRequest({
//     url,
//     method: 'delete',
//     data, // 请求参数放在请求体
//   })
// }

// // 电子学生证 put
// export function cardPut(url, data) {
//   return cardRequest({
//     url,
//     method: 'put',
//     data,
//   })
// }